export default __webpack_public_path__ + "static/media/services.830b6441.png";